import React from 'react';

import * as T from './interfaces';
import * as S from './styles';

export const MenuItem = ({
  isDisabled,
  id,
  children,
  imgOutsideContainer,
  ...rest
}: T.IMenuItemProps) => (
  <S.Wrapper
    imgOutsideContainer={imgOutsideContainer}
    data-testid={`${id}@MenuItem`}
    id={`${id}@MenuItem`}
    isDisabled={isDisabled}
    {...rest}
  >
    {children}
  </S.Wrapper>
);
